import React from "react";
import {
  FormGroup,
  Button,
  TextArea,
  Intent,
  Alert,
  Callout
} from "@blueprintjs/core";
import useEmailTab from "./EmailTabHooks";
import styles from "./EmailTab.module.scss";
import { Icon } from "../../../../atoms/Icon";

export default function EmailTab({ opportunityId, setShowShare, onDismiss }) {
  const {
    emails,
    setDescription,
    loading,
    isAlertOpen,
    setIsAlertOpen,
    invalidForm,
    error,
    onEmailsChange,
    onSendEmails
  } = useEmailTab({ opportunityId, onDismiss, setShowShare });

  return (
    <div>
      <Alert
        className={styles.confirmAlert}
        cancelButtonText="Cancel"
        confirmButtonText="Yes, don't save"
        icon={
          <Icon
            name="warning-sign"
            color="#7a869b"
            size={32}
            className={styles.confirmAlertIcon}
          />
        }
        intent="danger"
        isOpen={isAlertOpen}
        onCancel={() => setIsAlertOpen(false)}
        onConfirm={() => {
          setIsAlertOpen(false);
          setShowShare(false);
          onDismiss();
        }}
        canEscapeKeyCancel
        canOutsideClickCancel
      >
        <p className={styles.confirmAlertMessage}>
          Are you sure you want to dismiss without sharing? All your changes
          will be lost.
        </p>
      </Alert>

      {error && (
        <Callout
          intent={Intent.WARNING}
          title={error.title}
          style={{ marginBottom: "1em" }}
          icon={null}
        >
          {error.message}
        </Callout>
      )}

      <FormGroup label="Email Address">
        <TextArea
          type="text"
          autoCapitalize="none"
          autoCorrect="false"
          onChange={(e) => onEmailsChange(e)}
          placeholder="johndeo@email.com, mikedevis@email.com"
          fill
          intent={invalidForm ? Intent.DANGER : Intent.NONE}
        />
      </FormGroup>

      <div className={styles.formInfo}>
        {invalidForm ? (
          <p className={styles.error}>Invalid email address</p>
        ) : (
          <p className={styles.helperInfo}>
            Enter recipient email addresses separated by comma
          </p>
        )}
      </div>

      <FormGroup label="Description">
        <TextArea
          type="text"
          autoCapitalize="none"
          autoCorrect="false"
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Enter your message to be shared in the email (optional)"
          fill
        />
      </FormGroup>

      <div className={styles.footer}>
        <Button
          text="Cancel"
          style={{ marginRight: "10px" }}
          onClick={() => setIsAlertOpen(true)}
        />
        <Button
          text="Send"
          intent={Intent.PRIMARY}
          loading={loading}
          disabled={invalidForm || !emails}
          onClick={onSendEmails}
        />
      </div>
    </div>
  );
}
